exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-link-2b6OchWL {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  color: white;\n  font-size: 12px;\n  font-weight: 300;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n", ""]);

// exports
exports.locals = {
	"link": "styles-link-2b6OchWL"
};